<template>
  <div class="grid-box">
    <transition @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter">
      <!-- 投标模块 -->
      <div v-for="(paItem,i) in menuData" :key="i" class="items-box">
        <!-- 模块名称 -->
        <div class="grid-title" v-html="paItem.menu_name"></div>
        <!-- 模块名称结束 -->
        <!-- 头标展示区 -->
        <van-grid square :column-num="4" icon-size="1rem">
          <van-grid-item
            v-for="(item,index) in paItem.list"
            :key="nugIndex(index)"
            :icon="item.file_url"
            :text="item.menu_name"
            :class="[{'ashIcons':item.ashFlag ==1},item.ashFlag ==0?'van-info-red':'van-info-yellow']"
            :badge="item.ashFlag ==1?'':item.ashFlag ==0?'+':'-'"
            @click="item.ashFlag ==1?'':item.ashFlag ==0?addItems(item):delItems(item)"
            v-dragging="{item: item, list: paItem.list, group: 'item'}"
          />
        </van-grid>
        <!-- 头标展示区结束 -->
      </div>
      <!-- 投标模块结束 -->
    </transition>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    menuList: {
      type: Array
    }
  },
  watch: {
    menuList(val) {
      this.menuData = val; //给展示的list赋值
    }
  },
  data() {
    return {
      menuData: [] //接收父组件传递过来的menu数据
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.$dragging.$on("dragged", ({ value }) => {
      this.$emit("changeDrag", value.list);
    });
  },
  methods: {
    beforeEnter(el) {
    },
    enter(el, done) {},
    afterEnter(el, done) {
    },
    getChangeList(val) {
      console.log(val, "val");
    },
    getChangeLists(vals) {
      console.log(vals, "vals");
    },
    // 添加常用服务
    addItems(item) {
      this.$emit("addItem", item);
    },
    // 删除常用服务
    delItems(item) {
      this.$emit("delItem", item);
    },
    // 防止动态样式加不上，所有给:key加个随机数
    nugIndex(index) {
      return index + Math.round(Math.random() * 100000);
    },
    // 初始化函数
    init() {
      this.gianListData();
    },
    // 给展示的list赋值
    gianListData() {
      this.menuData = this.menuList;
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/reset.css';

.fade-enter-active {
  animation: fade-in 1s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}
.items-box {
  transition: all 0.5s;
}

>>>.name-text {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #B2B2B2;
  line-height: 18px;
  display: inline-block;
  margin-left: 10px;
}

>>>.ashIcons {
  img, span {
    opacity: 0.3;
  }
}

>>>.van-info-red {
  .van-info {
    background: #29BEBC;
  }
}

>>>.van-info-yellow {
  .van-info {
    background: #F9564B;
  }
}

.grid-box {
  .items-box {
    background: #fff;
    margin-bottom: 10px;
    padding-top: 10px;
  }

  .grid-title {
    color: #353535;
    font-size: 17px;
    padding: 0px 15px 10px;
    font-size: 17px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 24px;
  }

  .border {
    margin-bottom: 10px;

    div {
      border: 2px dashed #e5e5e5;
      width: 66%;
      margin: auto;
    }
  }
}
</style>